import React from 'react';
import Header from './components/layout/Header';
import Ensemble from './pages/Ensemble';
import Reunion from './pages/Reunion';
import Vehicule from './pages/Vehicule';
import Login from './pages/Login';
import Sign from './pages/Sign';
import PrivateRoute from './services/PrivateRoute';
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import AbsencePersonnel from './pages/AbsencePersonnel';

function App() {
  return (
    <div>
      <Router>
        <Header/>
        <Routes>
          <Route path="/" element={<PrivateRoute element={Ensemble} />} />
          <Route path="/vehicule" element={<PrivateRoute element={Vehicule} requiredCodes={['RLS','ARLC','AALPPSB','AALVACCIN','RSI','RBD','CEO','SBD']} />} />
          <Route path="/reunion" element={<PrivateRoute element={Reunion} />} />
          <Route path="/absence" element={<PrivateRoute element={AbsencePersonnel} requiredCodes={['RA', 'ARH','RSI','RBD','CEO','SBD']} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign" element={<Sign />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
